import { render, staticRenderFns } from "./WorkflowHistory.vue?vue&type=template&id=3e603844&scoped=true"
import script from "./WorkflowHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowHistory.vue?vue&type=script&lang=js"
import style0 from "./WorkflowHistory.vue?vue&type=style&index=0&id=3e603844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e603844",
  null
  
)

export default component.exports